// @ts-nocheck
import React, { FC, useState, useEffect } from 'react';
import styled from 'styled-components';
import _throttle from 'lodash/throttle';

import isOneOfThemInViewport from 'crehana-utils/isOneOfThemInViewport';
import PremiumCTABar from './PremiumCTABar';

import { EVENTS } from '../constants';

const Fixed = styled.div<{ isVisible: boolean }>`
  top: 20px;
  ${props => !props.isVisible && 'z-index: -10;'}
  ${({ theme }) => theme.breakpoints.up('sm')} {
    top: 40px;
    left: unset;
    right: 40px;
  }
`;

const ButtonWrapper = styled.div<{ isVisible: boolean }>`
  transform: translateY(${props => (props.isVisible ? '0%' : '-200%')});
  opacity: ${props => (props.isVisible ? '1' : '0')};
  transition: 0.3s;
`;

interface FixedCallToActionProps {
  scrollToSpecifiedSection(): void;
  banner: {
    message: string;
    alternativeShortMessage: string;
    expirationDate: Date;
  } | null;
  buttonLabel: string;
}

declare global {
  interface Window {
    mozRequestAnimationFrame?: () => void;
  }
}

const FixedCallToAction: FC<FixedCallToActionProps> = ({
  scrollToSpecifiedSection,
  banner,
  buttonLabel,
}) => {
  const [isVisible, setVisibility] = useState(false);
  const [hasRendered, setHasRendered] = useState(false);

  useEffect(() => {
    // requestAnimationFrame
    const raf =
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame || // tslint:disable-line
      function (callback) {
        window.setTimeout(callback, 1000 / 60);
      };
    const handler = _throttle(() => {
      const domIds = ['membershipv2-main-section', 'membershipv2-plans'];

      raf(() => {
        if (!isOneOfThemInViewport(domIds)) {
          setVisibility(true);
          if (!hasRendered) {
            setHasRendered(true);
          }
        } else {
          setVisibility(false);
        }
      });
    }, 150);

    handler();
    window.addEventListener('scroll', handler);

    return () => {
      window.removeEventListener('scroll', handler);
    };
  }, []);

  return (
    <Fixed
      isVisible={isVisible}
      className={`w-full fixed z-5 ${!isVisible ? 'overflow-y-hidden' : ''}`}
    >
      <ButtonWrapper isVisible={isVisible}>
        <PremiumCTABar
          banner={banner}
          buttonLabel={buttonLabel}
          onClick={() => {
            if (window.gtag) {
              window.gtag('event', 'Click a sticky', {
                send_to: 'UA-60829200-1',
                event_category: 'Membresias',
              });
            }
            scrollToSpecifiedSection();
          }}
        />
      </ButtonWrapper>
    </Fixed>
  );
};

export default FixedCallToAction;
